import { IAddress } from "../website/types";

export enum TestDriveBookingSteps {
  WELCOME_PAGE = "WELCOME_PAGE",
  BRANCH_SELECTION = "BRANCH_SELECTION",
  VEHICLE_SELECTION = "VEHCILE_SELECTION",
  VEHICLE_CONFIRMATION = "VEHICLE_CONFIRMATION",
  PERSONAL_DETAILS = "PERSONAL_DETAILS",
  CONFIRMATION = "CONFIRMATION",
}

export enum TestDriveTypes {
  STANDARD = "STANDARD",
  EXTENDED = "EXTENDED",
}

export enum TestDriveExperiences {
  CONSULTATION = "CONSULTATION",
}

export const testDriveTypesOptions = [
  { value: TestDriveTypes.STANDARD, label: "Standard Test Drive" },
  { value: TestDriveTypes.EXTENDED, label: "Extended Test Drive" },
];

export const testDriveExperienceOptions = [
  {
    value: TestDriveExperiences.CONSULTATION,
    label: "Consultation during Test Drive",
  },
];

interface IStepperData {
  dealership: string;
  model: string;
  slot: string;
  experience: string;
}

interface IAvailableBranches {
  branchId: string;
  vehicleGroupId: string;
}

export interface ITestDriveBookingDetails {
  experience: TestDriveExperiences;
  type: TestDriveTypes;
}

export enum DeliveryType {
  DEALERSHIP = "DEALERSHIP",
  HOME = "HOME",
}

export interface ITestDriveBookingState {
  vehicleGroupId: string;
  availableBranches: IAvailableBranches[];
  availableVehicleIds: string[];
  testDriveType: TestDriveTypes;
  branchId: string;
  vehicleId: string;
  extendedTestDriveDuration: number;
  currentStep: TestDriveBookingSteps;
  stepperData: IStepperData;
  pickupLocation: string;
  pickupOtherLocation: IAddress;
  vehicleImage: string;
  testDriveBookingDetails: ITestDriveBookingDetails;
  pickupSlot?: IDriverSlot;
  dropoffSlot?: IDriverSlot;
  dropoffDate?: string;
  pickupDate?: string;
  isBookingUpdate?: boolean;
  id?: string;
  deliveryType: DeliveryType;
}

export interface IDriverSlot {
  slotId: String;
  driverId: String;
}

export interface ITestDriveVehicleGroup {
  vehicleName: string;
  imageUrl?: string;
  vehicleIds: string[];
  colour?: string;
  bodyType?: string;
  transmission?: string;
  fuelType?: string;
  seats?: number;
  doors?: number;
  features?: string[];
  interiorFeatures?: string[];
  exteriorFeatures?: string[];
  safetyAndTechnicalFeatures?: string[];
}